module.exports = __webpack_public_path__ + "img/safetyImg8.d6b6b9db.png";